import React from "react";
import Tool from "./Tool";
import "../styles/Toolbox.css";
import {
  FaJs,
  FaHtml5,
  FaSass,
  FaCss3,
  FaReact,
  FaPython,
  FaNpm,
  FaYarn,
  FaBootstrap,
  FaNodeJs,
  
} from "react-icons/fa6";
import { SiRedux, SiTypescript, SiChakraui, SiMongodb,SiExpress,SiNextdotjs,SiTailwindcss } from "react-icons/si";
const Toolbox = () => {
  const mytools = [
    ["Javascript", 100, <FaJs style={{color:"yellow"}}/>],
    ["HTML", 200, <FaHtml5 style={{color:"brown"}}/>],
    ["SASS", 300, <FaSass style={{color:"pink"}}/>],
    ["CSS", 400, <FaCss3 style={{color:"blue"}}/>],
    ["React", 500, <FaReact style={{color:"lightblue"}}/>],
    ["Redux", 600, <SiRedux style={{color:"paleturquoise"}}/>],
    ["Python", 700, <FaPython />],
    ["Npm", 800, <FaNpm style={{color:"red"}}/>],
    ["Yarn", 900, <FaYarn style={{color:"lightblue"}}/>],
    ["Typescript", 1000, <SiTypescript style={{color:"blue"}}/>],
    ["Bootstrap", 1100, <FaBootstrap style={{color:"purple"}}/>],
    ["Chakra UI", 1200, <SiChakraui style={{color:"lightseagreen"}}/>],
    ["NodeJs", 1300, <FaNodeJs style={{color:"green"}}/>],
    ["MongoDB", 1400, <SiMongodb style={{color:"green"}}/>],
    ["ExpressJs", 1500,<SiExpress style={{color:"yellow"}}/>],
    ["Next.Js",1600,<SiNextdotjs style={{color:"white"}}/>],
    ["TailwindCSS",1700,<SiTailwindcss style={{color:"lightskyblue"}}/>]
  ];
  return (
    <div className="toolbox" id="toolbox">
      <p>Here are the tools and languages in my arsenal</p>
      <div className="tools">
        {mytools.map((tool, key) => {
          return (
            <Tool key={key} delay={tool[1]} tool={tool[0]} icon={tool[2]} />
          );
        })}
      </div>
    </div>
  );
};
export default Toolbox;
